export const ID_ME_BRAND_COLOR = '#08833D';
